import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'INSTITUTIONS/SETTINGS/AGE_GROUPS';

export const {action: selectIndex} = createAction(`${domain}/SELECT`, index => ({index}));

export const {action: reset} = createAction(`${domain}/RESET`);
